import { getErrorDetail } from 'components/utility/utils';
import { fetchOrchidAPI } from 'utils/api';

export default async function removeMemberFromTeam (
  teamId: number,
  memberId: string,
): Promise<void> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/team/${teamId}/remove/${memberId}`,
    {
        method: 'DELETE',
    }
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
}
